import { Label } from '../ui/Label';
import { cn } from '../../lib/utils';

/**
 * Plain-text editor for the stored HTML. Separate from the preview and the
 * check on purpose: the stored HTML string is the single source of truth,
 * and anything that edits it (this textarea today, a visual layer later)
 * just reads and writes that string.
 */
export function HtmlSourceEditor({
  id,
  value,
  onChange,
  disabled,
  className,
  label = 'HTML source',
}: {
  id: string;
  value: string;
  onChange: (html: string) => void;
  disabled?: boolean | undefined;
  className?: string;
  label?: string;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <textarea
        id={id}
        value={value}
        readOnly={disabled}
        spellCheck={false}
        autoCapitalize="off"
        autoCorrect="off"
        wrap="off"
        onChange={(e) => onChange(e.target.value)}
        className={cn(
          'w-full resize-y rounded-[9px] border border-zinc-300 bg-card p-3 font-mono text-[12.5px] leading-5 text-text',
          'whitespace-pre focus-visible:border-accent-hover',
          className ?? 'h-[560px]',
        )}
      />
    </div>
  );
}
